const buildSuffix = (url?: {query?: Record<string, string>, hash?: string}) => {
  const query = url?.query;
  const hash = url?.hash;
  if (!query && !hash) return '';
  const search = query ? `?${new URLSearchParams(query)}` : '';
  return `${search}${hash ? `#${hash}` : ''}`;
};

export const pagesPath = {
  "groupManager": {
    "folders": {
      _groupFolderId: (groupFolderId: string | number) => ({
        "accounts": {
          $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/folders/[groupFolderId]/accounts' as const, query: { groupFolderId }, hash: url?.hash, path: `/groupManager/folders/${groupFolderId}/accounts${buildSuffix(url)}` }),
        },
        "courses": {
          $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/folders/[groupFolderId]/courses' as const, query: { groupFolderId }, hash: url?.hash, path: `/groupManager/folders/${groupFolderId}/courses${buildSuffix(url)}` }),
        },
        "groupSetting": {
          $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/folders/[groupFolderId]/groupSetting' as const, query: { groupFolderId }, hash: url?.hash, path: `/groupManager/folders/${groupFolderId}/groupSetting${buildSuffix(url)}` }),
        },
        "reports": {
          $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/folders/[groupFolderId]/reports' as const, query: { groupFolderId }, hash: url?.hash, path: `/groupManager/folders/${groupFolderId}/reports${buildSuffix(url)}` }),
        },
        "setting": {
          $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/folders/[groupFolderId]/setting' as const, query: { groupFolderId }, hash: url?.hash, path: `/groupManager/folders/${groupFolderId}/setting${buildSuffix(url)}` }),
        },
      }),
    },
    "groups": {
      _groupId: (groupId: string | number) => ({
        "accounts": {
          _memberId: (memberId: string | number) => ({
            "badges": {
              $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/accounts/[memberId]/badges' as const, query: { groupId, memberId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/accounts/${memberId}/badges${buildSuffix(url)}` }),
            },
            "learning": {
              $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/accounts/[memberId]/learning' as const, query: { groupId, memberId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/accounts/${memberId}/learning${buildSuffix(url)}` }),
            },
            $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/accounts/[memberId]' as const, query: { groupId, memberId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/accounts/${memberId}${buildSuffix(url)}` }),
            "setting": {
              $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/accounts/[memberId]/setting' as const, query: { groupId, memberId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/accounts/${memberId}/setting${buildSuffix(url)}` }),
            },
            "test": {
              $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/accounts/[memberId]/test' as const, query: { groupId, memberId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/accounts/${memberId}/test${buildSuffix(url)}` }),
            },
          }),
          $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/accounts' as const, query: { groupId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/accounts${buildSuffix(url)}` }),
        },
        "announcements": {
          _announcementId: (announcementId: string | number) => ({
            "edit": {
              $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/announcements/[announcementId]/edit' as const, query: { groupId, announcementId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/announcements/${announcementId}/edit${buildSuffix(url)}` }),
            },
            $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/announcements/[announcementId]' as const, query: { groupId, announcementId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/announcements/${announcementId}${buildSuffix(url)}` }),
          }),
          "new": {
            $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/announcements/new' as const, query: { groupId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/announcements/new${buildSuffix(url)}` }),
          },
          $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/announcements' as const, query: { groupId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/announcements${buildSuffix(url)}` }),
        },
        "courses": {
          _courseId: (courseId: string | number) => ({
            "answers": {
              _answerId: (answerId: string | number) => ({
                $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/courses/[courseId]/answers/[answerId]' as const, query: { groupId, courseId, answerId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/courses/${courseId}/answers/${answerId}${buildSuffix(url)}` }),
              }),
              $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/courses/[courseId]/answers' as const, query: { groupId, courseId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/courses/${courseId}/answers${buildSuffix(url)}` }),
            },
            "members": {
              $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/courses/[courseId]/members' as const, query: { groupId, courseId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/courses/${courseId}/members${buildSuffix(url)}` }),
            },
          }),
          $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/courses' as const, query: { groupId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/courses${buildSuffix(url)}` }),
        },
        "dashboard": {
          $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/dashboard' as const, query: { groupId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/dashboard${buildSuffix(url)}` }),
        },
        "members": {
          $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/members' as const, query: { groupId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/members${buildSuffix(url)}` }),
        },
        "setting": {
          $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/setting' as const, query: { groupId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/setting${buildSuffix(url)}` }),
        },
        "team": {
          $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/team' as const, query: { groupId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/team${buildSuffix(url)}` }),
        },
        "test": {
          _testId: (testId: string | number) => ({
            _memberId: (memberId: string | number) => ({
              $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/test/[testId]/[memberId]' as const, query: { groupId, testId, memberId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/test/${testId}/${memberId}${buildSuffix(url)}` }),
            }),
            $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/test/[testId]' as const, query: { groupId, testId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/test/${testId}${buildSuffix(url)}` }),
          }),
          "answers": {
            $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/test/answers' as const, query: { groupId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/test/answers${buildSuffix(url)}` }),
          },
          $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/test' as const, query: { groupId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/test${buildSuffix(url)}` }),
        },
        "timeline": {
          $url: (url?: { hash?: string }) => ({ pathname: '/groupManager/groups/[groupId]/timeline' as const, query: { groupId }, hash: url?.hash, path: `/groupManager/groups/${groupId}/timeline${buildSuffix(url)}` }),
        },
      }),
    },
  },
  "manager": {
    "analytics": {
      $url: (url?: { hash?: string }) => ({ pathname: '/manager/analytics' as const, hash: url?.hash, path: `/manager/analytics${buildSuffix(url)}` }),
    },
    "announcements": {
      _announcementId: (announcementId: string | number) => ({
        "edit": {
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/announcements/[announcementId]/edit' as const, query: { announcementId }, hash: url?.hash, path: `/manager/announcements/${announcementId}/edit${buildSuffix(url)}` }),
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/manager/announcements/[announcementId]' as const, query: { announcementId }, hash: url?.hash, path: `/manager/announcements/${announcementId}${buildSuffix(url)}` }),
      }),
      "new": {
        $url: (url?: { hash?: string }) => ({ pathname: '/manager/announcements/new' as const, hash: url?.hash, path: `/manager/announcements/new${buildSuffix(url)}` }),
      },
      $url: (url?: { hash?: string }) => ({ pathname: '/manager/announcements' as const, hash: url?.hash, path: `/manager/announcements${buildSuffix(url)}` }),
      "templates": {
        $url: (url?: { hash?: string }) => ({ pathname: '/manager/announcements/templates' as const, hash: url?.hash, path: `/manager/announcements/templates${buildSuffix(url)}` }),
      },
    },
    "courses": {
      _courseId: (courseId: string | number) => ({
        "changes": {
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/courses/[courseId]/changes' as const, query: { courseId }, hash: url?.hash, path: `/manager/courses/${courseId}/changes${buildSuffix(url)}` }),
        },
        "icon": {
          "generate": {
            $url: (url?: { hash?: string }) => ({ pathname: '/manager/courses/[courseId]/icon/generate' as const, query: { courseId }, hash: url?.hash, path: `/manager/courses/${courseId}/icon/generate${buildSuffix(url)}` }),
          },
        },
        "import": {
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/courses/[courseId]/import' as const, query: { courseId }, hash: url?.hash, path: `/manager/courses/${courseId}/import${buildSuffix(url)}` }),
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/manager/courses/[courseId]' as const, query: { courseId }, hash: url?.hash, path: `/manager/courses/${courseId}${buildSuffix(url)}` }),
        "parts": {
          _partId: (partId: string | number) => ({
            $url: (url?: { hash?: string }) => ({ pathname: '/manager/courses/[courseId]/parts/[partId]' as const, query: { courseId, partId }, hash: url?.hash, path: `/manager/courses/${courseId}/parts/${partId}${buildSuffix(url)}` }),
            "questions": {
              _questionId: (questionId: string | number) => ({
                $url: (url?: { hash?: string }) => ({ pathname: '/manager/courses/[courseId]/parts/[partId]/questions/[questionId]' as const, query: { courseId, partId, questionId }, hash: url?.hash, path: `/manager/courses/${courseId}/parts/${partId}/questions/${questionId}${buildSuffix(url)}` }),
              }),
            },
          }),
          "new": {
            $url: (url?: { hash?: string }) => ({ pathname: '/manager/courses/[courseId]/parts/new' as const, query: { courseId }, hash: url?.hash, path: `/manager/courses/${courseId}/parts/new${buildSuffix(url)}` }),
          },
        },
      }),
      "new": {
        $url: (url?: { hash?: string }) => ({ pathname: '/manager/courses/new' as const, hash: url?.hash, path: `/manager/courses/new${buildSuffix(url)}` }),
      },
      $url: (url?: { hash?: string }) => ({ pathname: '/manager/courses' as const, hash: url?.hash, path: `/manager/courses${buildSuffix(url)}` }),
    },
    "members": {
      _memberId: (memberId: string | number) => ({
        "badges": {
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/members/[memberId]/badges' as const, query: { memberId }, hash: url?.hash, path: `/manager/members/${memberId}/badges${buildSuffix(url)}` }),
        },
        "groups": {
          _groupId: (groupId: string | number) => ({
            $url: (url?: { hash?: string }) => ({ pathname: '/manager/members/[memberId]/groups/[groupId]' as const, query: { memberId, groupId }, hash: url?.hash, path: `/manager/members/${memberId}/groups/${groupId}${buildSuffix(url)}` }),
          }),
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/members/[memberId]/groups' as const, query: { memberId }, hash: url?.hash, path: `/manager/members/${memberId}/groups${buildSuffix(url)}` }),
        },
        "profile": {
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/members/[memberId]/profile' as const, query: { memberId }, hash: url?.hash, path: `/manager/members/${memberId}/profile${buildSuffix(url)}` }),
        },
        "setting": {
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/members/[memberId]/setting' as const, query: { memberId }, hash: url?.hash, path: `/manager/members/${memberId}/setting${buildSuffix(url)}` }),
        },
        "test": {
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/members/[memberId]/test' as const, query: { memberId }, hash: url?.hash, path: `/manager/members/${memberId}/test${buildSuffix(url)}` }),
        },
      }),
      "import": {
        $url: (url?: { hash?: string }) => ({ pathname: '/manager/members/import' as const, hash: url?.hash, path: `/manager/members/import${buildSuffix(url)}` }),
        "upload": {
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/members/import/upload' as const, hash: url?.hash, path: `/manager/members/import/upload${buildSuffix(url)}` }),
        },
      },
      "new": {
        "email": {
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/members/new/email' as const, hash: url?.hash, path: `/manager/members/new/email${buildSuffix(url)}` }),
        },
        "email_multiple": {
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/members/new/email_multiple' as const, hash: url?.hash, path: `/manager/members/new/email_multiple${buildSuffix(url)}` }),
        },
        "employee_number": {
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/members/new/employee_number' as const, hash: url?.hash, path: `/manager/members/new/employee_number${buildSuffix(url)}` }),
        },
      },
      $url: (url?: { hash?: string }) => ({ pathname: '/manager/members' as const, hash: url?.hash, path: `/manager/members${buildSuffix(url)}` }),
    },
    "organizations": {
      $url: (url?: { hash?: string }) => ({ pathname: '/manager/organizations' as const, hash: url?.hash, path: `/manager/organizations${buildSuffix(url)}` }),
    },
    "redash": {
      $url: (url?: { hash?: string }) => ({ pathname: '/manager/redash' as const, hash: url?.hash, path: `/manager/redash${buildSuffix(url)}` }),
    },
    "courseDetail": {
      _courseID: (courseID: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/manager/courseDetail/[courseID]' as const, query: { courseID }, hash: url?.hash, path: `/manager/courseDetail/${courseID}${buildSuffix(url)}` }),
      }),
    },
    "groups": {
      _groupId: (groupId: string | number) => ({
        "accounts": {
          _memberId: (memberId: string | number) => ({
            "badges": {
              $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/accounts/[memberId]/badges' as const, query: { groupId, memberId }, hash: url?.hash, path: `/manager/groups/${groupId}/accounts/${memberId}/badges${buildSuffix(url)}` }),
            },
            "learning": {
              $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/accounts/[memberId]/learning' as const, query: { groupId, memberId }, hash: url?.hash, path: `/manager/groups/${groupId}/accounts/${memberId}/learning${buildSuffix(url)}` }),
            },
            $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/accounts/[memberId]' as const, query: { groupId, memberId }, hash: url?.hash, path: `/manager/groups/${groupId}/accounts/${memberId}${buildSuffix(url)}` }),
            "setting": {
              $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/accounts/[memberId]/setting' as const, query: { groupId, memberId }, hash: url?.hash, path: `/manager/groups/${groupId}/accounts/${memberId}/setting${buildSuffix(url)}` }),
            },
            "test": {
              $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/accounts/[memberId]/test' as const, query: { groupId, memberId }, hash: url?.hash, path: `/manager/groups/${groupId}/accounts/${memberId}/test${buildSuffix(url)}` }),
            },
          }),
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/accounts' as const, query: { groupId }, hash: url?.hash, path: `/manager/groups/${groupId}/accounts${buildSuffix(url)}` }),
        },
        "announcements": {
          _announcementId: (announcementId: string | number) => ({
            $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/announcements/[announcementId]' as const, query: { groupId, announcementId }, hash: url?.hash, path: `/manager/groups/${groupId}/announcements/${announcementId}${buildSuffix(url)}` }),
          }),
          "new": {
            $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/announcements/new' as const, query: { groupId }, hash: url?.hash, path: `/manager/groups/${groupId}/announcements/new${buildSuffix(url)}` }),
          },
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/announcements' as const, query: { groupId }, hash: url?.hash, path: `/manager/groups/${groupId}/announcements${buildSuffix(url)}` }),
        },
        "courses": {
          _courseId: (courseId: string | number) => ({
            "answers": {
              _answerId: (answerId: string | number) => ({
                $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/courses/[courseId]/answers/[answerId]' as const, query: { groupId, courseId, answerId }, hash: url?.hash, path: `/manager/groups/${groupId}/courses/${courseId}/answers/${answerId}${buildSuffix(url)}` }),
              }),
              $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/courses/[courseId]/answers' as const, query: { groupId, courseId }, hash: url?.hash, path: `/manager/groups/${groupId}/courses/${courseId}/answers${buildSuffix(url)}` }),
            },
            "members": {
              $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/courses/[courseId]/members' as const, query: { groupId, courseId }, hash: url?.hash, path: `/manager/groups/${groupId}/courses/${courseId}/members${buildSuffix(url)}` }),
            },
          }),
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/courses' as const, query: { groupId }, hash: url?.hash, path: `/manager/groups/${groupId}/courses${buildSuffix(url)}` }),
        },
        "dashboard": {
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/dashboard' as const, query: { groupId }, hash: url?.hash, path: `/manager/groups/${groupId}/dashboard${buildSuffix(url)}` }),
        },
        "members": {
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/members' as const, query: { groupId }, hash: url?.hash, path: `/manager/groups/${groupId}/members${buildSuffix(url)}` }),
        },
        "setting": {
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/setting' as const, query: { groupId }, hash: url?.hash, path: `/manager/groups/${groupId}/setting${buildSuffix(url)}` }),
        },
        "team": {
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/team' as const, query: { groupId }, hash: url?.hash, path: `/manager/groups/${groupId}/team${buildSuffix(url)}` }),
        },
        "test": {
          _testId: (testId: string | number) => ({
            _memberId: (memberId: string | number) => ({
              $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/test/[testId]/[memberId]' as const, query: { groupId, testId, memberId }, hash: url?.hash, path: `/manager/groups/${groupId}/test/${testId}/${memberId}${buildSuffix(url)}` }),
            }),
            $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/test/[testId]' as const, query: { groupId, testId }, hash: url?.hash, path: `/manager/groups/${groupId}/test/${testId}${buildSuffix(url)}` }),
          }),
          "answers": {
            $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/test/answers' as const, query: { groupId }, hash: url?.hash, path: `/manager/groups/${groupId}/test/answers${buildSuffix(url)}` }),
          },
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/test' as const, query: { groupId }, hash: url?.hash, path: `/manager/groups/${groupId}/test${buildSuffix(url)}` }),
        },
        "timeline": {
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/[groupId]/timeline' as const, query: { groupId }, hash: url?.hash, path: `/manager/groups/${groupId}/timeline${buildSuffix(url)}` }),
        },
      }),
      "folders": {
        _groupFolderId: (groupFolderId: string | number) => ({
          "accounts": {
            $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/folders/[groupFolderId]/accounts' as const, query: { groupFolderId }, hash: url?.hash, path: `/manager/groups/folders/${groupFolderId}/accounts${buildSuffix(url)}` }),
          },
          "courses": {
            $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/folders/[groupFolderId]/courses' as const, query: { groupFolderId }, hash: url?.hash, path: `/manager/groups/folders/${groupFolderId}/courses${buildSuffix(url)}` }),
          },
          "groupSetting": {
            $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/folders/[groupFolderId]/groupSetting' as const, query: { groupFolderId }, hash: url?.hash, path: `/manager/groups/folders/${groupFolderId}/groupSetting${buildSuffix(url)}` }),
          },
          "reports": {
            $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/folders/[groupFolderId]/reports' as const, query: { groupFolderId }, hash: url?.hash, path: `/manager/groups/folders/${groupFolderId}/reports${buildSuffix(url)}` }),
          },
          "setting": {
            $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/folders/[groupFolderId]/setting' as const, query: { groupFolderId }, hash: url?.hash, path: `/manager/groups/folders/${groupFolderId}/setting${buildSuffix(url)}` }),
          },
        }),
        "new": {
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/folders/new' as const, hash: url?.hash, path: `/manager/groups/folders/new${buildSuffix(url)}` }),
        },
      },
      "import": {
        $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/import' as const, hash: url?.hash, path: `/manager/groups/import${buildSuffix(url)}` }),
        "upload": {
          "change": {
            $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/import/upload/change' as const, hash: url?.hash, path: `/manager/groups/import/upload/change${buildSuffix(url)}` }),
          },
          "delete": {
            $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/import/upload/delete' as const, hash: url?.hash, path: `/manager/groups/import/upload/delete${buildSuffix(url)}` }),
          },
        },
      },
      "new": {
        $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups/new' as const, hash: url?.hash, path: `/manager/groups/new${buildSuffix(url)}` }),
      },
      $url: (url?: { hash?: string }) => ({ pathname: '/manager/groups' as const, hash: url?.hash, path: `/manager/groups${buildSuffix(url)}` }),
    },
    $url: (url?: { hash?: string }) => ({ pathname: '/manager' as const, hash: url?.hash, path: `/manager${buildSuffix(url)}` }),
    "settings": {
      $url: (url?: { hash?: string }) => ({ pathname: '/manager/settings' as const, hash: url?.hash, path: `/manager/settings${buildSuffix(url)}` }),
    },
    "tests": {
      _testId: (testId: string | number) => ({
        _questionId: (questionId: string | number) => ({
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/tests/[testId]/[questionId]' as const, query: { testId, questionId }, hash: url?.hash, path: `/manager/tests/${testId}/${questionId}${buildSuffix(url)}` }),
        }),
        "import": {
          $url: (url?: { hash?: string }) => ({ pathname: '/manager/tests/[testId]/import' as const, query: { testId }, hash: url?.hash, path: `/manager/tests/${testId}/import${buildSuffix(url)}` }),
          "upload": {
            $url: (url?: { hash?: string }) => ({ pathname: '/manager/tests/[testId]/import/upload' as const, query: { testId }, hash: url?.hash, path: `/manager/tests/${testId}/import/upload${buildSuffix(url)}` }),
          },
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/manager/tests/[testId]' as const, query: { testId }, hash: url?.hash, path: `/manager/tests/${testId}${buildSuffix(url)}` }),
      }),
      "new": {
        $url: (url?: { hash?: string }) => ({ pathname: '/manager/tests/new' as const, hash: url?.hash, path: `/manager/tests/new${buildSuffix(url)}` }),
      },
      $url: (url?: { hash?: string }) => ({ pathname: '/manager/tests' as const, hash: url?.hash, path: `/manager/tests${buildSuffix(url)}` }),
    },
  },
  _groupId: (groupId: string | number) => ({
    "announcements": {
      _announcementId: (announcementId: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/[groupId]/announcements/[announcementId]' as const, query: { groupId, announcementId }, hash: url?.hash, path: `/${groupId}/announcements/${announcementId}${buildSuffix(url)}` }),
      }),
      $url: (url?: { hash?: string }) => ({ pathname: '/[groupId]/announcements' as const, query: { groupId }, hash: url?.hash, path: `/${groupId}/announcements${buildSuffix(url)}` }),
    },
    "courses": {
      $url: (url?: { hash?: string }) => ({ pathname: '/[groupId]/courses' as const, query: { groupId }, hash: url?.hash, path: `/${groupId}/courses${buildSuffix(url)}` }),
      _courseId: (courseId: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/[groupId]/courses/[courseId]' as const, query: { groupId, courseId }, hash: url?.hash, path: `/${groupId}/courses/${courseId}${buildSuffix(url)}` }),
        "parts": {
          _partId: (partId: string | number) => ({
            "contact": {
              $url: (url?: { hash?: string }) => ({ pathname: '/[groupId]/courses/[courseId]/parts/[partId]/contact' as const, query: { groupId, courseId, partId }, hash: url?.hash, path: `/${groupId}/courses/${courseId}/parts/${partId}/contact${buildSuffix(url)}` }),
            },
            $url: (url?: { hash?: string }) => ({ pathname: '/[groupId]/courses/[courseId]/parts/[partId]' as const, query: { groupId, courseId, partId }, hash: url?.hash, path: `/${groupId}/courses/${courseId}/parts/${partId}${buildSuffix(url)}` }),
            "result": {
              _challengeId: (challengeId: string | number) => ({
                $url: (url?: { hash?: string }) => ({ pathname: '/[groupId]/courses/[courseId]/parts/[partId]/result/[challengeId]' as const, query: { groupId, courseId, partId, challengeId }, hash: url?.hash, path: `/${groupId}/courses/${courseId}/parts/${partId}/result/${challengeId}${buildSuffix(url)}` }),
              }),
            },
            "start": {
              $url: (url?: { hash?: string }) => ({ pathname: '/[groupId]/courses/[courseId]/parts/[partId]/start' as const, query: { groupId, courseId, partId }, hash: url?.hash, path: `/${groupId}/courses/${courseId}/parts/${partId}/start${buildSuffix(url)}` }),
            },
          }),
        },
      }),
    },
    "dashboard": {
      $url: (url?: { hash?: string }) => ({ pathname: '/[groupId]/dashboard' as const, query: { groupId }, hash: url?.hash, path: `/${groupId}/dashboard${buildSuffix(url)}` }),
    },
    "home": {
      $url: (url?: { hash?: string }) => ({ pathname: '/[groupId]/home' as const, query: { groupId }, hash: url?.hash, path: `/${groupId}/home${buildSuffix(url)}` }),
    },
    "profile": {
      _userId: (userId: string | number) => ({
        "badges": {
          $url: (url?: { hash?: string }) => ({ pathname: '/[groupId]/profile/[userId]/badges' as const, query: { groupId, userId }, hash: url?.hash, path: `/${groupId}/profile/${userId}/badges${buildSuffix(url)}` }),
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/[groupId]/profile/[userId]' as const, query: { groupId, userId }, hash: url?.hash, path: `/${groupId}/profile/${userId}${buildSuffix(url)}` }),
      }),
    },
    "team": {
      $url: (url?: { hash?: string }) => ({ pathname: '/[groupId]/team' as const, query: { groupId }, hash: url?.hash, path: `/${groupId}/team${buildSuffix(url)}` }),
    },
    "tests": {
      _testId: (testId: string | number) => ({
        _challengeId: (challengeId: string | number) => ({
          $url: (url?: { hash?: string }) => ({ pathname: '/[groupId]/tests/[testId]/[challengeId]' as const, query: { groupId, testId, challengeId }, hash: url?.hash, path: `/${groupId}/tests/${testId}/${challengeId}${buildSuffix(url)}` }),
          "result": {
            $url: (url?: { hash?: string }) => ({ pathname: '/[groupId]/tests/[testId]/[challengeId]/result' as const, query: { groupId, testId, challengeId }, hash: url?.hash, path: `/${groupId}/tests/${testId}/${challengeId}/result${buildSuffix(url)}` }),
          },
        }),
        $url: (url?: { hash?: string }) => ({ pathname: '/[groupId]/tests/[testId]' as const, query: { groupId, testId }, hash: url?.hash, path: `/${groupId}/tests/${testId}${buildSuffix(url)}` }),
      }),
      $url: (url?: { hash?: string }) => ({ pathname: '/[groupId]/tests' as const, query: { groupId }, hash: url?.hash, path: `/${groupId}/tests${buildSuffix(url)}` }),
    },
    "timeline": {
      $url: (url?: { hash?: string }) => ({ pathname: '/[groupId]/timeline' as const, query: { groupId }, hash: url?.hash, path: `/${groupId}/timeline${buildSuffix(url)}` }),
    },
  }),
  "group_init": {
    $url: (url?: { hash?: string }) => ({ pathname: '/group-init' as const, hash: url?.hash, path: `/group-init${buildSuffix(url)}` }),
  },
  "changeEmail": {
    "complete": {
      $url: (url?: { hash?: string }) => ({ pathname: '/changeEmail/complete' as const, hash: url?.hash, path: `/changeEmail/complete${buildSuffix(url)}` }),
    },
    $url: (url?: { hash?: string }) => ({ pathname: '/changeEmail' as const, hash: url?.hash, path: `/changeEmail${buildSuffix(url)}` }),
  },
  "guest": {
    "courses": {
      _courseId: (courseId: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/guest/courses/[courseId]' as const, query: { courseId }, hash: url?.hash, path: `/guest/courses/${courseId}${buildSuffix(url)}` }),
        "parts": {
          _partId: (partId: string | number) => ({
            $url: (url?: { hash?: string }) => ({ pathname: '/guest/courses/[courseId]/parts/[partId]' as const, query: { courseId, partId }, hash: url?.hash, path: `/guest/courses/${courseId}/parts/${partId}${buildSuffix(url)}` }),
          }),
        },
      }),
    },
  },
  "login": {
    "inviteLink": {
      "done": {
        $url: (url?: { hash?: string }) => ({ pathname: '/login/inviteLink/done' as const, hash: url?.hash, path: `/login/inviteLink/done${buildSuffix(url)}` }),
      },
      $url: (url?: { hash?: string }) => ({ pathname: '/login/inviteLink' as const, hash: url?.hash, path: `/login/inviteLink${buildSuffix(url)}` }),
    },
    "organizationId": {
      $url: (url?: { hash?: string }) => ({ pathname: '/login/organizationId' as const, hash: url?.hash, path: `/login/organizationId${buildSuffix(url)}` }),
    },
    $url: (url?: { hash?: string }) => ({ pathname: '/login' as const, hash: url?.hash, path: `/login${buildSuffix(url)}` }),
    "saml": {
      "callback": {
        $url: (url?: { hash?: string }) => ({ pathname: '/login/saml/callback' as const, hash: url?.hash, path: `/login/saml/callback${buildSuffix(url)}` }),
      },
    },
    "set_password": {
      $url: (url?: { hash?: string }) => ({ pathname: '/login/set-password' as const, hash: url?.hash, path: `/login/set-password${buildSuffix(url)}` }),
    },
    "set_password_confirm": {
      $url: (url?: { hash?: string }) => ({ pathname: '/login/set-password-confirm' as const, hash: url?.hash, path: `/login/set-password-confirm${buildSuffix(url)}` }),
    },
    "set_password_done": {
      $url: (url?: { hash?: string }) => ({ pathname: '/login/set-password-done' as const, hash: url?.hash, path: `/login/set-password-done${buildSuffix(url)}` }),
    },
  },
  "new_password": {
    $url: (url?: { hash?: string }) => ({ pathname: '/new-password' as const, hash: url?.hash, path: `/new-password${buildSuffix(url)}` }),
  },
  "reset_password": {
    $url: (url?: { hash?: string }) => ({ pathname: '/reset-password' as const, hash: url?.hash, path: `/reset-password${buildSuffix(url)}` }),
  },
  "reset_password_confirm": {
    $url: (url?: { hash?: string }) => ({ pathname: '/reset-password-confirm' as const, hash: url?.hash, path: `/reset-password-confirm${buildSuffix(url)}` }),
  },
  "reset_password_done": {
    $url: (url?: { hash?: string }) => ({ pathname: '/reset-password-done' as const, hash: url?.hash, path: `/reset-password-done${buildSuffix(url)}` }),
  },
  "iOSPWA": {
    $url: (url?: { hash?: string }) => ({ pathname: '/iOSPWA' as const, hash: url?.hash, path: `/iOSPWA${buildSuffix(url)}` }),
  },
  "setting": {
    $url: (url?: { hash?: string }) => ({ pathname: '/setting' as const, hash: url?.hash, path: `/setting${buildSuffix(url)}` }),
    "pushNotifications": {
      $url: (url?: { hash?: string }) => ({ pathname: '/setting/pushNotifications' as const, hash: url?.hash, path: `/setting/pushNotifications${buildSuffix(url)}` }),
    },
  },
  "signup": {
    $url: (url?: { hash?: string }) => ({ pathname: '/signup' as const, hash: url?.hash, path: `/signup${buildSuffix(url)}` }),
  },
  "confirm": {
    $url: (url?: { hash?: string }) => ({ pathname: '/confirm' as const, hash: url?.hash, path: `/confirm${buildSuffix(url)}` }),
  },
  "contact": {
    $url: (url?: { hash?: string }) => ({ pathname: '/contact' as const, hash: url?.hash, path: `/contact${buildSuffix(url)}` }),
  },
  "expired": {
    $url: (url?: { hash?: string }) => ({ pathname: '/expired' as const, hash: url?.hash, path: `/expired${buildSuffix(url)}` }),
  },
  $url: (url?: { hash?: string }) => ({ pathname: '/' as const, hash: url?.hash, path: `/${buildSuffix(url)}` }),
  "parent_organization": {
    _parentOrganizationId: (parentOrganizationId: string | number) => ({
      "announcements": {
        _bulkAnnouncementId: (bulkAnnouncementId: string | number) => ({
          "edit": {
            $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/announcements/[bulkAnnouncementId]/edit' as const, query: { parentOrganizationId, bulkAnnouncementId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/announcements/${bulkAnnouncementId}/edit${buildSuffix(url)}` }),
          },
          $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/announcements/[bulkAnnouncementId]' as const, query: { parentOrganizationId, bulkAnnouncementId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/announcements/${bulkAnnouncementId}${buildSuffix(url)}` }),
        }),
        "new": {
          $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/announcements/new' as const, query: { parentOrganizationId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/announcements/new${buildSuffix(url)}` }),
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/announcements' as const, query: { parentOrganizationId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/announcements${buildSuffix(url)}` }),
      },
      "courses": {
        _courseId: (courseId: string | number) => ({
          "contents": {
            $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/courses/[courseId]/contents' as const, query: { parentOrganizationId, courseId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/courses/${courseId}/contents${buildSuffix(url)}` }),
          },
          "detail": {
            $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/courses/[courseId]/detail' as const, query: { parentOrganizationId, courseId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/courses/${courseId}/detail${buildSuffix(url)}` }),
          },
          "edit": {
            $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/courses/[courseId]/edit' as const, query: { parentOrganizationId, courseId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/courses/${courseId}/edit${buildSuffix(url)}` }),
          },
          "parts": {
            _partId: (partId: string | number) => ({
              $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/courses/[courseId]/parts/[partId]' as const, query: { parentOrganizationId, courseId, partId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/courses/${courseId}/parts/${partId}${buildSuffix(url)}` }),
              "questions": {
                _questionId: (questionId: string | number) => ({
                  $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/courses/[courseId]/parts/[partId]/questions/[questionId]' as const, query: { parentOrganizationId, courseId, partId, questionId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/courses/${courseId}/parts/${partId}/questions/${questionId}${buildSuffix(url)}` }),
                }),
              },
            }),
          },
          "preview": {
            $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/courses/[courseId]/preview' as const, query: { parentOrganizationId, courseId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/courses/${courseId}/preview${buildSuffix(url)}` }),
          },
          "update": {
            $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/courses/[courseId]/update' as const, query: { parentOrganizationId, courseId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/courses/${courseId}/update${buildSuffix(url)}` }),
          },
        }),
        "new": {
          $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/courses/new' as const, query: { parentOrganizationId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/courses/new${buildSuffix(url)}` }),
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/courses' as const, query: { parentOrganizationId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/courses${buildSuffix(url)}` }),
      },
      "franchise_managers": {
        _franchiseManagerId: (franchiseManagerId: string | number) => ({
          "setting": {
            $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/franchise_managers/[franchiseManagerId]/setting' as const, query: { parentOrganizationId, franchiseManagerId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/franchise_managers/${franchiseManagerId}/setting${buildSuffix(url)}` }),
          },
        }),
        "new": {
          $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/franchise_managers/new' as const, query: { parentOrganizationId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/franchise_managers/new${buildSuffix(url)}` }),
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/franchise_managers' as const, query: { parentOrganizationId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/franchise_managers${buildSuffix(url)}` }),
      },
      "group_sync": {
        $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/group_sync' as const, query: { parentOrganizationId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/group_sync${buildSuffix(url)}` }),
      },
      "organizations": {
        _organizationId: (organizationId: string | number) => ({
          "members": {
            "import": {
              $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/organizations/[organizationId]/members/import' as const, query: { parentOrganizationId, organizationId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/organizations/${organizationId}/members/import${buildSuffix(url)}` }),
              "upload": {
                $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/organizations/[organizationId]/members/import/upload' as const, query: { parentOrganizationId, organizationId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/organizations/${organizationId}/members/import/upload${buildSuffix(url)}` }),
              },
            },
            "new": {
              "email": {
                $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/organizations/[organizationId]/members/new/email' as const, query: { parentOrganizationId, organizationId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/organizations/${organizationId}/members/new/email${buildSuffix(url)}` }),
              },
              "email_multiple": {
                $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/organizations/[organizationId]/members/new/email_multiple' as const, query: { parentOrganizationId, organizationId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/organizations/${organizationId}/members/new/email_multiple${buildSuffix(url)}` }),
              },
              "employee_number": {
                $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/organizations/[organizationId]/members/new/employee_number' as const, query: { parentOrganizationId, organizationId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/organizations/${organizationId}/members/new/employee_number${buildSuffix(url)}` }),
              },
            },
            $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/organizations/[organizationId]/members' as const, query: { parentOrganizationId, organizationId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/organizations/${organizationId}/members${buildSuffix(url)}` }),
          },
        }),
        $url: (url?: { hash?: string }) => ({ pathname: '/parent_organization/[parentOrganizationId]/organizations' as const, query: { parentOrganizationId }, hash: url?.hash, path: `/parent_organization/${parentOrganizationId}/organizations${buildSuffix(url)}` }),
      },
    }),
  },
  "system_admin": {
    "analytics": {
      $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/analytics' as const, hash: url?.hash, path: `/system_admin/analytics${buildSuffix(url)}` }),
    },
    "announcementTemplates": {
      $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/announcementTemplates' as const, hash: url?.hash, path: `/system_admin/announcementTemplates${buildSuffix(url)}` }),
    },
    "courses": {
      _courseId: (courseId: string | number) => ({
        "contents": {
          $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/courses/[courseId]/contents' as const, query: { courseId }, hash: url?.hash, path: `/system_admin/courses/${courseId}/contents${buildSuffix(url)}` }),
        },
        "detail": {
          $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/courses/[courseId]/detail' as const, query: { courseId }, hash: url?.hash, path: `/system_admin/courses/${courseId}/detail${buildSuffix(url)}` }),
        },
        "edit": {
          $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/courses/[courseId]/edit' as const, query: { courseId }, hash: url?.hash, path: `/system_admin/courses/${courseId}/edit${buildSuffix(url)}` }),
        },
        "import": {
          $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/courses/[courseId]/import' as const, query: { courseId }, hash: url?.hash, path: `/system_admin/courses/${courseId}/import${buildSuffix(url)}` }),
        },
        "parts": {
          _partId: (partId: string | number) => ({
            $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/courses/[courseId]/parts/[partId]' as const, query: { courseId, partId }, hash: url?.hash, path: `/system_admin/courses/${courseId}/parts/${partId}${buildSuffix(url)}` }),
            "questions": {
              _questionId: (questionId: string | number) => ({
                $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/courses/[courseId]/parts/[partId]/questions/[questionId]' as const, query: { courseId, partId, questionId }, hash: url?.hash, path: `/system_admin/courses/${courseId}/parts/${partId}/questions/${questionId}${buildSuffix(url)}` }),
              }),
            },
          }),
        },
        "preview": {
          $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/courses/[courseId]/preview' as const, query: { courseId }, hash: url?.hash, path: `/system_admin/courses/${courseId}/preview${buildSuffix(url)}` }),
        },
        "publish": {
          $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/courses/[courseId]/publish' as const, query: { courseId }, hash: url?.hash, path: `/system_admin/courses/${courseId}/publish${buildSuffix(url)}` }),
        },
        "update": {
          $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/courses/[courseId]/update' as const, query: { courseId }, hash: url?.hash, path: `/system_admin/courses/${courseId}/update${buildSuffix(url)}` }),
        },
      }),
      "new": {
        $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/courses/new' as const, hash: url?.hash, path: `/system_admin/courses/new${buildSuffix(url)}` }),
      },
      $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/courses' as const, hash: url?.hash, path: `/system_admin/courses${buildSuffix(url)}` }),
    },
    "files": {
      _fileId: (fileId: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/files/[fileId]' as const, query: { fileId }, hash: url?.hash, path: `/system_admin/files/${fileId}${buildSuffix(url)}` }),
      }),
      $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/files' as const, hash: url?.hash, path: `/system_admin/files${buildSuffix(url)}` }),
    },
    "organizations": {
      _organizationId: (organizationId: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/organizations/[organizationId]' as const, query: { organizationId }, hash: url?.hash, path: `/system_admin/organizations/${organizationId}${buildSuffix(url)}` }),
      }),
      "fc_child_register": {
        $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/organizations/fc_child_register' as const, hash: url?.hash, path: `/system_admin/organizations/fc_child_register${buildSuffix(url)}` }),
      },
      "new": {
        $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/organizations/new' as const, hash: url?.hash, path: `/system_admin/organizations/new${buildSuffix(url)}` }),
      },
      $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/organizations' as const, hash: url?.hash, path: `/system_admin/organizations${buildSuffix(url)}` }),
      "template": {
        $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/organizations/template' as const, hash: url?.hash, path: `/system_admin/organizations/template${buildSuffix(url)}` }),
      },
    },
    $url: (url?: { hash?: string }) => ({ pathname: '/system_admin' as const, hash: url?.hash, path: `/system_admin${buildSuffix(url)}` }),
    "parts": {
      _partId: (partId: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/parts/[partId]' as const, query: { partId }, hash: url?.hash, path: `/system_admin/parts/${partId}${buildSuffix(url)}` }),
      }),
    },
    "questions": {
      _questionId: (questionId: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/questions/[questionId]' as const, query: { questionId }, hash: url?.hash, path: `/system_admin/questions/${questionId}${buildSuffix(url)}` }),
      }),
    },
    "system_admin_users": {
      "append": {
        $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/system_admin_users/append' as const, hash: url?.hash, path: `/system_admin/system_admin_users/append${buildSuffix(url)}` }),
      },
      $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/system_admin_users' as const, hash: url?.hash, path: `/system_admin/system_admin_users${buildSuffix(url)}` }),
    },
    "tests": {
      _testId: (testId: string | number) => ({
        _questionId: (questionId: string | number) => ({
          $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/tests/[testId]/[questionId]' as const, query: { testId, questionId }, hash: url?.hash, path: `/system_admin/tests/${testId}/${questionId}${buildSuffix(url)}` }),
        }),
        $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/tests/[testId]' as const, query: { testId }, hash: url?.hash, path: `/system_admin/tests/${testId}${buildSuffix(url)}` }),
        "publishToOrganization": {
          $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/tests/[testId]/publishToOrganization' as const, query: { testId }, hash: url?.hash, path: `/system_admin/tests/${testId}/publishToOrganization${buildSuffix(url)}` }),
        },
      }),
      "new": {
        $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/tests/new' as const, hash: url?.hash, path: `/system_admin/tests/new${buildSuffix(url)}` }),
      },
      $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/tests' as const, hash: url?.hash, path: `/system_admin/tests${buildSuffix(url)}` }),
    },
    "users": {
      _userId: (userId: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/users/[userId]' as const, query: { userId }, hash: url?.hash, path: `/system_admin/users/${userId}${buildSuffix(url)}` }),
      }),
      $url: (url?: { hash?: string }) => ({ pathname: '/system_admin/users' as const, hash: url?.hash, path: `/system_admin/users${buildSuffix(url)}` }),
    },
  },
};

export type PagesPath = typeof pagesPath;
